import { tracked } from '@glimmer/tracking';

import type { APIData, GeneralComponentClass } from 'webapp-types';

import InfolayerTypeLoopPdfComponent from 'webapp/components/infolayer/type-loop-pdf';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemSnapshotBase from 'webapp/models-custom/infolayer-item/snapshot-base';

export interface LoopLikeType {
	title: string;
	specificSourceTypesKeys: string[];
}

export interface ConstructorData extends BaseConstructorData {
	loop: LoopLikeType;
}

export default class InfolayerItemLoopPdf extends InfolayerItemSnapshotBase {
	componentClass: GeneralComponentClass = InfolayerTypeLoopPdfComponent;

	@tracked snapshotData: APIData.Snapshot.Response | null = null;
	@tracked loop: LoopLikeType;

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.loop = data.loop;
	}

	override setDone(snapshotData: APIData.Snapshot.Response) {
		this.snapshotData = snapshotData;
		super.setDone(snapshotData);
	}

	protected override isSameType(item: InfolayerItemBase) {
		return super.isSameType(item) && item instanceof InfolayerItemLoopPdf;
	}
}
